import { render, staticRenderFns } from "./NotificationInbox.vue?vue&type=template&id=eeda5674&"
import script from "./NotificationInbox.vue?vue&type=script&lang=js&"
export * from "./NotificationInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports